/* eslint-disable import/no-named-as-default */
import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { components } from '@episource/epi-storybook';
import { ErrorPage } from '@episource/analyst-ui-components';
import List from '@material-ui/core/List';
import Header from '../Header';
import AdminUsers from '../AdminUsers';
import AdminUserDetail from '../AdminUserDetail';
import AdminClients from '../AdminClients';
import AdminClientForm from '../AdminClientForm';
import AdminClientDetail from '../AdminClientDetail';
import AdminUserForm from '../AdminUserForm';
import { ListItems } from './ListItems';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

const { SideNavVersion2 } = components;

function Administration({ appMeta }) {
  const classes = useStyles();
  const appBarRef = useRef(null);

  const pathName = useLocation().pathname;

  let activeNavItem = '';
  if (pathName.split('/').length === 2) {
    activeNavItem = appMeta.isInternal ? 'clients' : 'users';
  } else {
    // eslint-disable-next-line prefer-destructuring
    activeNavItem = pathName.split('/')[2];
  }
  return appMeta.isAdmin ? (
    <>
      <Header forwardedRef={appBarRef} activeNavItem={activeNavItem} />
      <div className={classes.root}>
        <SideNavVersion2 appBarRef={appBarRef}>
          <List className={classes.list}>{ListItems({ activeNavItem, appMeta })}</List>
        </SideNavVersion2>
        <div className={classes.content}>
          <Switch>
            <Route exact path="/administration/clients" render={() => <AdminClients />} />
            <Route exact path="/administration/users" render={() => <AdminUsers />} />
            <Route exact path="/administration/users/create" render={() => <AdminUserForm />} />
            <Route exact path="/administration/clients/create" render={() => <AdminClientForm />} />
            <Route path="/administration/clients/:id" component={AdminClientDetail} />
            <Route path="/administration/users/:id" component={AdminUserDetail} />
            <Route exact path="/administration/privileges" render={() => <></>} />
            <Redirect push strict from="/administration" to="/administration/clients" />
            <Route exact path="/administration/users" render={() => <AdminUsers />} />
            <Route exact path="/administration/users/create" render={() => <AdminUserForm />} />
            <Route path="/administration/users/:id" component={AdminUserDetail} />
            <Redirect push strict from="/administration" to="/administration/users" />
          </Switch>
        </div>
      </div>
    </>
  ) : (
    <Switch>
      <Route render={() => <ErrorPage />} />
    </Switch>
  );
}

Administration.propTypes = {
  appMeta: PropTypes.shape({
    isInternal: PropTypes.bool,
    isAdmin: PropTypes.bool,
  }).isRequired,
};

const mapStateToProps = state => {
  const { auth } = state;
  return {
    appMeta: auth.profile[process.env.REACT_APP_APP_METADATA_KEY].episourceAccess,
  };
};

export default connect(mapStateToProps, () => ({}))(Administration);
